import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from '../../shared/services/auth.service';






@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent {

  constructor( 
    public router: Router,
    public authService: AuthService
              ) {
   



  }

 
  
  

}
